import styled from 'styled-components';

import { mobileFirstBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled(BlockContainer)`
    width: 100%;
    margin-top: -32px;

    @media (min-width: ${mobileFirstBreakpoints.tablet}) {
        padding-top: 96px;
    }
`;

export const JoinWrapper = styled(IndentContainer)`
    width: 100%;
    margin-bottom: -50px;
    background-color: ${COLORS.BgSurface};

    @media (min-width: ${mobileFirstBreakpoints.laptop}) {
        padding-bottom: 128px;
    }
`;
